import uniqBy from "lodash/uniqBy";
import SentimentVeryDissatisfiedIcon from "@material-ui/icons/SentimentVeryDissatisfied";
import SentimentDissatisfiedIcon from "@material-ui/icons/SentimentDissatisfied";
import SentimentSatisfiedIcon from "@material-ui/icons/SentimentSatisfied";
import SentimentSatisfiedAltIcon from "@material-ui/icons/SentimentSatisfiedAltOutlined";
import SentimentVerySatisfiedIcon from "@material-ui/icons/SentimentVerySatisfied";
import LooksOneIcon from "@material-ui/icons/LooksOne";
import LooksTwoIcon from "@material-ui/icons/LooksTwo";
import Looks3Icon from "@material-ui/icons/Looks3";
import Looks4Icon from "@material-ui/icons/Looks4";
import Looks5Icon from "@material-ui/icons/Looks5";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import { supportEmail } from "../constants";
import auth from "../services/auth";
import { ACCOUNT_TYPE, ROLE_REPORT_GEN_LIMIT } from "./constants";
import moment from "moment";

export const twoDecimalPrecision = 2;

export const regexForTwoDecimal = /([0-9]*[\.]{0,1}[0-9]{0,2})/s;

export const regexForSixDigitsAndNoValueAfterDecimal = /^[0-9]{1,6}$/;

/**
 * This method is used to convert value upto 2 decimal places, formatter indicates precision accuracy
 * @param number
 * @param formatter
 * @returns formatted number upto 3 decimal
 */
export const getDecimalFormat = (number, formatter) => {
  return number.toFixed(formatter);
};

export const handleMultiSelectChange = (
  _,
  actionMeta,
  multiList,
  multiSelection,
  allSelectOption
) => {
  let newList = multiSelection;
  const { action, option, removedValue } = actionMeta;
  if (action === "select-option") {
    if (option.value === allSelectOption.value) {
      newList = [...multiList];
    } else {
      newList = [...multiSelection];
      newList.push(option);
    }
  } else if (action === "remove-value") {
    newList = multiSelection.filter(
      ({ value }) => value !== removedValue.value
    );
  } else if (action === "clear") {
    newList = [];
  }
  return newList;
};

export const getMultiSelectOptionsInCaseOfInactiveAndDelete = (
  multiList,
  multiSelection,
  allSelectOption
) => {
  if (multiList != undefined) {
    let selectionOptions = [...multiList, ...multiSelection];
    selectionOptions = uniqBy(selectionOptions, "value");
    if (multiSelection?.length == selectionOptions?.length) {
      return [...selectionOptions];
    } else {
      return [allSelectOption, ...selectionOptions];
    }
  }
  return [];
};

export const getMultiSelectOptions = (
  multiList,
  multiSelection,
  allSelectOption
) => {
  if (multiList != undefined) {
    if (multiSelection?.length == multiList?.length) {
      return [...multiSelection];
    } else {
      return [allSelectOption, ...multiList];
    }
  }
  return [];
};

/**
 * These are exports for the dropdowns
 */
export const selectAllStakeholders = {
  value: "*",
  label: "All StakeHolders",
};

export const selectAllProtagonist = {
  value: "*",
  label: "All Protagonist",
};

export const selectAllPsel = {
  value: "*",
  label: "All PSEL Standards",
};

export const selectAllNelp = {
  value: "*",
  label: "All NELP Standards",
};

export const selectAllIntasc = {
  value: "*",
  label: "All InTasc Standards",
};

export const selectAllCaep = {
  value: "*",
  label: "All CAEP Standards",
};

export const selectAllAaqepStandards = {
  value: "*",
  label: "All AAQEP Standards",
};
export const selectAllNaceStandards = {
  value: "*",
  label: "All NACE Standards",
};
export const selectAllMceeStandards = {
  value: "*",
  label: "All MCEE Standards",
};

export const selectAllKeyTopics = {
  value: "*",
  label: "All SubTypes",
};

export const selectAllKeyTopicsForFilter = {
  value: "*",
  label: "-- Select All Key Topics --",
};

export const selectAllAccounts = {
  value: "*",
  label: "All Accounts",
};

export const selectAllSimulations = {
  value: "*",
  label: "All Simulations",
};

export const selectAllOptionCohorts = {
  value: "*",
  label: "All Cohorts",
};

export const selectAllStakeholdersForFilter = {
  value: "*",
  label: "-- Select All StakeHolders --",
};

export const selectAllProtagonistFilter = {
  value: "*",
  label: "-- Select All Protagonist --",
};

export const selectAllPselFilter = {
  value: "*",
  label: "-- Select All PSEL Standards --",
};

export const selectAllNelpFilter = {
  value: "*",
  label: "-- Select All NELP Standards --",
};

export const selectAllIntascFilter = {
  value: "*",
  label: "-- Select All InTasc Standards --",
};

export const selectAllCaepFilter = {
  value: "*",
  label: "-- Select All CAEP Standards --",
};

export const selectAllProductTypes = {
  value: "*",
  label: "-- Select All Product Types --",
};

export const selectAllAAQEPForFilter = {
  value: "*",
  label: "-- Select All AAQEP Standards --",
};

export const selectAllNACEForFilter = {
  value: "*",
  label: "-- Select All NACE Standards --",
};

export const selectAllMCEEForFilter = {
  value: "*",
  label: "-- Select All MCEE Standards --",
};

export const selectAllStandards = {
  value: "*",
  label: "All Standards",
};

export const selectAllSimulationByAccount = {
  value: "*",
  label: "All Simulations",
};

export const selectAllRegions = {
  value: "*",
  label: "All Regions",
};

export const selectAllEmails = {
  value: "*",
  label: "All Emails",
};

export const altAttribute = Object.freeze({
  logoAlt: "School Sims",
  profileAlt: "Profile",
});

export const ckEditorConfiguration = Object.freeze({
  forClassManagement: {
    toolbar: [
      "undo",
      "redo",
      "|",
      "heading",
      "|",
      "bold",
      "italic",
      "fontColor",
      "|",
      "alignment",
      "|",
      "blockQuote",
      "|",
      "link",
      "|",
      "numberedList",
      "bulletedList",
    ],
  },
  forAdManagement: {
    toolbar: [
      "undo",
      "redo",
      "|",
      "heading",
      "|",
      "bold",
      "italic",
      "fontColor",
      "|",
      "alignment",
      "|",
      "blockQuote",
      "|",
      "link",
      "|",
      "imageUpload",
      "|",
      "numberedList",
      "bulletedList",
    ],
    image: {
      toolbar: [
        "imageTextAlternative",
        "|",
        "imageStyle:alignLeft",
        "alignCenter",
        "imageStyle:inline",
        "imageStyle:block",
        "imageStyle:alignRight",
        "|",
        "linkImage",
      ],
    },
  },
});

export const base64ToImage = (base64Image, uniqueName) => {
  const base64ImageSplitArray = base64Image.split(",");
  const mimeType = base64ImageSplitArray[0].match(/:(.*?);/)[1];
  const decodedData = atob(
    base64ImageSplitArray[base64ImageSplitArray.length - 1]
  );
  let decodeDataLength = decodedData.length;
  const u8arr = new Uint8Array(decodeDataLength);
  while (decodeDataLength--) {
    u8arr[decodeDataLength] = decodedData.charCodeAt(decodeDataLength);
  }
  return new File([u8arr], `${uniqueName}.${mimeType.split("/")[1]}`, {
    type: mimeType,
  });
};

export const textToDom = (text) => {
  return new DOMParser().parseFromString(text, "text/html");
};

/**
 * This method return the true is substring is contain in value otherwise it return false
 * @param value
 * @param substring
 * @returns Boolean
 */
export const isConatinSubsrting = (value, substring) => {
  return value?.includes(substring);
};

/**
 * This method add the inActive elements in the original list and then return the original list
 * @param orginalList
 * @param inActiveElemetns
 * return Array
 */
export const listWithInActiveElements = (originalList, inActiveElements) => {
  const list = [...originalList];
  const inActive = "InActive";

  if (Array.isArray(inActiveElements)) {
    inActiveElements.forEach((element) => {
      if (isConatinSubsrting(element?.label, inActive)) {
        list.push(element);
      }
    });
  } else {
    if (isConatinSubsrting(inActiveElements?.label, inActive)) {
      list.push(inActiveElements);
    }
  }

  return list;
};

export const MAX_CHARACTER_LIMITS_FOR_ELIPSIS = 450;

/**
 * This method will convert base64 to excel &  return the excel file
 * @param base64String
 */
export const base64ToExcel = (base64String, name) => {
  // Decode the base64 string
  const binaryString = atob(base64String);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  // Creating a Blob from the bytes
  const blob = new Blob([bytes], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  // Creating a link element
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = name;

  // Append the link to the body
  document.body.appendChild(link);

  // Programmatically click the link to trigger the download
  link.click();

  // Remove the link from the document
  document.body.removeChild(link);
};

/**
 * This method will find account by its value
 * @param arr
 * @param value
 * @returns
 */
export const findAccountByValue = (arr, value) => {
  for (const obj of arr) {
    if (obj.value === value) {
      return { value: obj.value, label: obj.label };
    }
  }
  return null;
};

/**
 * Generic handle KeyDown
 * @param action
 * @returns
 */
export const handleKeyDown = (action: any) => (event: any) => {
  if (event.key === "Enter" || event.key === " ") {
    event.preventDefault();
    action();
  }
};

export const customIcon = {
  1: {
    icon: <SentimentVeryDissatisfiedIcon style={{ color: "#EA7F64" }} />,
    label: "Very Dissatisfied",
  },
  2: {
    icon: <SentimentDissatisfiedIcon style={{ color: "#F4B46C" }} />,
    label: "Dissatisfied",
  },
  3: {
    icon: <SentimentSatisfiedIcon style={{ color: "#F5D577" }} />,
    label: "Neutral",
  },
  4: {
    icon: <SentimentSatisfiedAltIcon style={{ color: "#B9E38F" }} />,
    label: "Satisfied",
  },
  5: {
    icon: <SentimentVerySatisfiedIcon style={{ color: "#7ED580" }} />,
    label: "Very Satisfied",
  },
};

export const accreditationTypeReports = [
  { value: 1, label: "Accreditation Variable Result" },
  { value: 2, label: "Free Text Response Scoring" },
];

export const simType = [
  {
    value: "Asynchronous",
    label: "Asynchronous SIM",
  },
  {
    value: "Facilitated",
    label: "Facilitated SIM",
  },
];

export const ValidateEmail = (mail) => {
  const validation =
    /^(([^#/*+!{}<>()[\]\\.,;:\s@\'"|\%~\^]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gim;
  return validation.test(mail);
};

export const PIE_CHART_COLORS = [
  "#146182",
  "#e97133",
  "#196b24",
  "#0f9ed5",
  "#a12b93",
  "#4fa72e",
];

export const PRE_SIM_RATING_QUESTIONS = {
  preq2:
    "I often get the chance to rehearse in advance the decisions I must make at work.",
  preq3: "I am confident in the decisions I make every day.",
  preq4: "I often get time to reflect on my decisions.",
  preq5: "My decisions have gotten more complicated in recent years.",
  preq6: "I often feel stressed about the decisions I must make at work.",
};

export const POST_SIM_RATING_QUESTIONS = {
  postq2: "I feel more confident in handling a future situation like this one.",
  postq3:
    "The situation was more complicated than I thought at first; I noticed more factors at play by the end.",
  postq4: "I am more aware of differing perspectives my peers might have.",
  postq5: "I am more aware of how I think about my decisions.",
  postq6: "This relates to my work.",
  postq7: "This will affect how I think about my work.",
  postq8: "This will affect what I do in my work.",
};

export const Wellness_RATING_QUESTIONS = {
  q1Rating: "How would you rate your overall well-being this week?",
  q2Rating: "How supported do you feel by your administration and colleagues?",
  q3Rating: "How manageable has your workload felt this week?",
  q4Rating: "How often have you felt overwhelmed or stressed this week?",
  q5Rating: "Have you been able to maintain a healthy work-life balance?",
  q7Rating:
    "How often have you felt engaged and motivated in your role this week?",
};

export const truncateText = (text, maxLength) => {
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};

export const surveyFrequency = Object.freeze({
  oneTime: "one-time",
  weekly: "weekly",
  monthly: "monthly",
});

export const surveys = Object.freeze({
  wellness: "Wellness Survey",
  jobConfidence: "Job Confidence Survey",
});

export const splitEmailStringIntoBatches = (emailString, batchSize = 50) => {
  const batches = [];
  let startIdx = 0;
  let count = 0;

  for (let i = 0; i < emailString.length; i++) {
    if (emailString[i] === ",") {
      count++;

      if (count === batchSize) {
        batches.push(emailString.slice(startIdx, i));
        startIdx = i + 1;
        count = 0;
      }
    }
  }

  if (startIdx < emailString.length) {
    batches.push(emailString.slice(startIdx).trim());
  }

  return batches;
};

export const ratingIcons = {
  1: {
    icon: <LooksOneIcon style={{ color: "#EA7F64" }} />,
    label: "Strongly disagree",
  },
  2: {
    icon: <LooksTwoIcon style={{ color: "#F4B46C" }} />,
    label: "Somewhat disagree",
  },
  3: {
    icon: <Looks3Icon style={{ color: "#F5D577" }} />,
    label: "Neither agree nor disagree",
  },
  4: {
    icon: <Looks4Icon style={{ color: "#B9E38F" }} />,
    label: "Somewhat agree",
  },
  5: {
    icon: <Looks5Icon style={{ color: "#7ED580" }} />,
    label: "Strongly agree",
  },
};

export const yesNoIcons = {
  1: {
    icon: <CheckCircleIcon style={{ color: "#EA7F64" }} />,
    label: "Yes",
  },
  2: {
    icon: <CancelIcon style={{ color: "#F4B46C" }} />,
    label: "No",
  },
};

export const actualRatingYesNoValue = { 1: true, 2: false };

export const emailBodyText = "<h4>Welcome to SchoolSims.</h4>";

export const parseAndValidateEmails = (emailsData) => {
  if (!emailsData) return { validEmails: [], error: null };

  let mailList = emailsData
    .split(/[\n,;]+/)
    .filter(Boolean)
    .map((e) => e.trim());

  const invalidEmail = mailList.find((email) => !ValidateEmail(email));

  if (invalidEmail) {
    return {
      validEmails: [],
      error:
        "Please enter valid email addresses separated by comma or semicolon.",
    };
  }

  return { validEmails: mailList, error: null };
};

/**
 * This method give the status of the sruvey
 * @param showMessage
 * @returns String
 */
export const giveSurveyLinkStatusMessage = (showMessage) => {
  if (showMessage.isFormSubmitted) {
    return <>Thanks for your feedback</>;
  }
  if (showMessage.isLinkSubmitted) {
    return <>You already submitted this survey.</>;
  }
  if (showMessage.isLinkValid) {
    return (
      <>
        Your survey link has been expired. Please contact the administrator at{" "}
        <a href={supportEmail}>{supportEmail}</a>
      </>
    );
  }
  return "";
};

/**
 * Thie method give the state of the survey link
 * @param surveyLinkData
 * @param surveyName
 * @returns array
 */
export const getSurveyLinkState = (surveyLinkData, surveyName) => {
  const isLinkSubmitted = surveyLinkData.isLinkSubmitted;
  const isLinkValid =
    surveyLinkData.isLinkExpire ||
    !surveyLinkData.isActive ||
    !surveyLinkData.isNotDeleted ||
    surveyName != surveyLinkData.surveyName;
  const isShowMessage = isLinkSubmitted || isLinkValid;
  const isShowForm = !isShowMessage;
  return { isShowMessage, isLinkSubmitted, isLinkValid, isShowForm };
};

/**
 * This method give the group name of account type by its type
 * @param accountType
 * @returns
 */
export const getGroupAccountTypesByEducationLevel = (accountType) => {
  let groupAccountTypeName = "";
  if (auth.getUserDetails().roleName === "Role_Super_Admin") {
    groupAccountTypeName =
      accountType === ACCOUNT_TYPE.HIGHER_ED ? "Higher Ed" : "K-12";
  }
  return groupAccountTypeName;
};

export const cohortReports = Object.freeze({
  cohortProgressReportLabel: "Cohort Progress Report",
  wellnessReportLabel: "Wellness Report",
  jobConfidenceReportLabel: "Job Confidence Report",
});

/**
 * Validates if the selected date range is within the allowed limit
 * based on user role.
 *
 * - Super Admin → 90 days limit
 * - Client Admin → 120 days limit
 *
 * Returns a warning message if the limit is exceeded, otherwise an empty string.
 *
 * @param startDate Start date of the range
 * @param endDate End date of the range
 * @param role User role ("Role_Super_Admin" | "Role_Admin")
 * @returns Message string or empty string
 */
export const isWithinAllowedDays = (startDate, endDate, role) => {
  if (!(startDate instanceof Date) || !(endDate instanceof Date)) {
    throw new Error("Both startDate and endDate must be Date objects");
  }

  // Get max days from the map
  const maxDays = ROLE_REPORT_GEN_LIMIT[role];

  const start = moment(startDate).startOf("day");
  const end = moment(endDate).startOf("day");

  const diffInDays = end.diff(start, "days") + 1; // adding 1 to include both start and end dates

  // Build and return message dynamically if limit exceeded
  return diffInDays > maxDays
    ? `Please select a date range of ${maxDays} days or less to generate the report.`
    : "";
};

export const blobUrlToBase64 = async (blobUrl) => {
  const response = await fetch(blobUrl);
  const blob = await response.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result); // <-- Base64 STRING
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

/** Same as FileUploader: send the blob bytes to S3, not a base64 round-trip. */
export const blobUrlToFile = async (blobUrl, uniqueName) => {
  const response = await fetch(blobUrl);
  const blob = await response.blob();
  const mimeType = blob.type || "application/octet-stream";
  const subtype = (mimeType.split("/")[1] || "bin").split(";")[0];
  return new File([blob], `${uniqueName}.${subtype}`, { type: mimeType });
};

// Get the first date of the next month formatted as 'en-US' locale date string
export const getNextMonthFirstDateFormatted=()=> {
  return new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1)
    .toLocaleDateString('en-US');
}
